import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

export default function SectionNavigation({ sections }) {
	const [activeSection, setActiveSection] = useState(sections[0]?.id || "");
	const [isSticky, setIsSticky] = useState(false);

	useEffect(() => {
		const handleScroll = () => {
			setIsSticky(window.scrollY > 300);

			const sectionElements = sections.map((section) => ({
				id: section.id,
				element: document.getElementById(section.id),
			}));

			const currentSection = sectionElements.find((section) => {
				if (!section.element) return false;
				const rect = section.element.getBoundingClientRect();
				return rect.top <= 150 && rect.bottom >= 150;
			});

			if (currentSection) {
				setActiveSection(currentSection.id);
			}
		};

		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, [sections]);

	const scrollToSection = (sectionId) => {
		const element = document.getElementById(sectionId);
		if (element) {
			const offset = 100;
			const elementPosition = element.getBoundingClientRect().top;
			const offsetPosition = elementPosition + window.pageYOffset - offset;

			window.scrollTo({
				top: offsetPosition,
				behavior: "smooth",
			});
		}
	};

	return (
		<motion.div
			className={`section-nav${isSticky ? " section-nav--sticky" : ""}`}
			initial={{ opacity: 0, y: -20 }}
			animate={{ opacity: 1, y: 0 }}
		>
			<div className="section-nav__container">
				<nav className="section-nav__list scrollbar-hide">
					{sections.map((section) => (
						<button
							key={section.id}
							type="button"
							onClick={() => scrollToSection(section.id)}
							className={`section-nav__item${
								activeSection === section.id ? " section-nav__item--active" : ""
							}`}
						>
							{section.label}
						</button>
					))}
				</nav>
			</div>
		</motion.div>
	);
}
